import React from "react";
import RecruitModalBase from "./RecruitModalContent/RecruitModalBase";
import useRecruitsUpdate from "../../hooks/useRecruitsUpdate";

/**
 * UpdateRecruitModal - Component for updating an existing recruit
 *
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Function to close the modal
 * @param {Object} props.recruitData - The data of the recruit to update
 * @param {string} [props.modal_header="Редактировать кандидата"] - Modal header text
 */
const UpdateRecruitModal = ({
  isOpen,
  onClose,
  recruitData,
  modal_header = "Редактировать кандидата",
}) => {
  const { updateRecruit } = useRecruitsUpdate();

  if (!recruitData && isOpen) {
    console.error("UpdateRecruitModal opened without recruit data");
    return null;
  }

  // The key is important to force React to recreate the component when a different recruit is edited
  return (
    <RecruitModalBase
      key={recruitData ? `edit-${recruitData.id}` : "new-recruit"}
      isOpen={isOpen}
      onClose={onClose}
      modalTitle={modal_header}
      initialData={recruitData || {}}
      onSubmit={updateRecruit}
      submitButtonText="Обновить"
      isEditMode={true}
    />
  );
};

export default UpdateRecruitModal;
